import { Component, OnInit, Input, OnDestroy, ViewChild } from '@angular/core';
import { MessageService, MenuItem } from 'primeng/api';
import {
    ServiceTypeEnum, XpressUserRoleEnum, RiderVehicleTypeEnum, OnboardingModel,
    FieldTypeEnum, ServiceAndVehicleTypeModel, MenuPermissionConfig, MenuPermissionActionEnum, XpressRiderStatus,
    RiderTransportationTypeEnum,
} from 'app/models';
import { ConfigService, RiderService, SignalrService, XpressUserService, AppDataService } from 'app/services';
import { Utils } from 'app/utils';
import * as moment from 'moment';
import { Observable, Subscription } from 'rxjs';
import { ColumnSelectorComponent } from 'app/column-selector/column-selector.component';
import { EditTableConfig } from 'app/models/configs/edit-table-config';
import { TableLazyLoadEvent } from 'primeng/table';
import {
    ResponceErrorCode
} from '../../../../../XpressTransfer/app/transfer/components/transfer/shared/enums/response-error-code.enum';
import { RegistrationMenuEnum } from 'app/registration-vehicles/registration-vehicles.component';

enum MenuEnum {
    NeedsReview = 1,
    InProgress = 2,
    OnHold = 3,
    Denied = 4,
    Probation = 5
}

export class TopCardDto {
    public Header: string = '';
    public Amount: string = '';
    public IconPath: string = '';
    public RegistrationStep: number = 0;
}

interface CreateApplicationForm {
    fullName: string;
    phone: string;
    birthDate: Date | null;
    email: string;
    address: string;
    emergencyContactName: string;
    emergencyContactPhone: string;
    serviceTypeId: ServiceTypeEnum;
    transportationType: RiderTransportationTypeEnum;
    vehicleTypeId: RiderVehicleTypeEnum;
    isSalaried: boolean;
    isEVDriver: boolean;
}

interface CreateApplicationErrors {
    fullName?: string;
    phone?: string;
    birthDate?: string;
    email?: string;
    address?: string;
    emergencyContactName?: string;
    emergencyContactPhone?: string;
}

@Component({
    selector: 'registration-v2',
    templateUrl: './registration-v2.component.html',
    styleUrls: ['./registration-v2.component.scss',
        '../../../../styles/paginator.scss'],
    providers: [MessageService]
})
export class RegistrationV2Component implements OnInit, OnDestroy {
    @Input()
    public menuPermissionActive!: string;

    @ViewChild(ColumnSelectorComponent)
    public columnSelector!: ColumnSelectorComponent;

    $onboarding: Observable<any>;
    $onboardingSubject: Subscription | undefined;

    public menuPermissionConfig = MenuPermissionConfig;
    public menuPermissionActionEnum = MenuPermissionActionEnum;

    // Grid
    public defaultCols: any[] = [];
    public cols: any[] = [];

    public rowsPerPage: number = 10;
    public totalRecords: number = -1;

    public skip: number = 0;
    public first: number = 0;
    public sortField: string | string[] = '';
    private sortOrder: number = 1;
    // End Grid

    public menuEnum = MenuEnum;
    public activeMenu: MenuEnum = MenuEnum.NeedsReview;
    public headerTitleName: string = 'New Applications';
    public tableName: string = '';

    private searchTimer: number = 0;
    public fieldTypeEnum = FieldTypeEnum;

    public onboarding = new OnboardingModel();
    public onboardingHeaderSearch: any = {
        id: null,
        age: null,
        rejectedDocuments: null,
        rejectedReasons: null,
        signupDate: null,
        type: null,
        driverName: null,
        phone: null,
        status: null,
        lastActiveTypeObj: null,
        updatedByUserId: null,
        riderId: null,
        inspectorName: null,
        verificationApplicationDate: null,
        probationDate: null
    };

    public arrayFilterStatuses: any = [];
    public arrayFilterLastUpdatedBy: any = [];

    public serviceType: ServiceTypeEnum = ServiceTypeEnum.None;
    public vehicleType: RiderVehicleTypeEnum = RiderVehicleTypeEnum.None;
    public serviceAndVehicleTypeList = ServiceAndVehicleTypeModel.GetServiceAndVehicleTypeList;

    selectedRegStep: MenuEnum = MenuEnum.NeedsReview;
    actionBtnTxt: string = 'Start Verifying';
    public commonCols: any[] = [
        {
            field: 'ApplicationId', header: 'Application Id', width: '10%', fieldType: FieldTypeEnum.InputNumber, model: 'id',
            placeholder: 'Type here', isObject: false, active: false, isLink: false
        },
        {
            field: 'SignupDate', header: 'ADT', width: '20%', fieldType: FieldTypeEnum.Calendar, model: 'signupDate',
            placeholder: 'Date & Time', isObject: false, active: false, isLink: false
        },
        {
            field: 'UserName', header: 'Driver Name', width: '20%', fieldType: FieldTypeEnum.Inputs, model: 'driverName',
            placeholder: 'Type here', isObject: false, active: false, isLink: true
        },
        {
            field: 'Phone', header: 'Phone No.', width: '20%', fieldType: FieldTypeEnum.Inputs, model: 'phone',
            placeholder: 'Type here', isObject: false, active: false, isLink: false
        },
        {
            field: 'ServiceAndVehicleTypeText', header: 'Type', width: '20%', disableSort: false, fieldType: FieldTypeEnum.Dropdown, model: 'type',
            options: this.serviceAndVehicleTypeList, placeholder: 'Please Select', isObject: true, active: false, isLink: false
        },
    ];

    public riderVehicleServiceTypeId: number = 0;
    public breadcrumbs: MenuItem[] = [{ icon: 'icon_back_office' }, { label: 'Application' },
        { label: 'Drivers' }, { label: 'Registration (v2)' }];

    public cards: Array<TopCardDto> = [];

    public selectedRiderId: number = 0;
    public selectedRiderVehicleId: number = 0;
    public selectedXpressUserId: number = 0;
    public isVisibleRegistrationAppProgressModal: boolean = false;
    public showLockDialog: boolean = false;
    public lockDialogText: string = '';

    public showCreateApplicationModal: boolean = false;
    public isCreatingApplication: boolean = false;
    public createAppMaxBirthDate: Date = new Date();
    public createAppForm: CreateApplicationForm = this.buildEmptyCreateAppForm();
    public createAppErrors: CreateApplicationErrors = {};
    public createAppServiceOptions = [
        { label: 'Ride', value: ServiceTypeEnum.Ride },
        { label: 'Taxi', value: ServiceTypeEnum.Taxi },
        { label: 'ConneX', value: ServiceTypeEnum.Connex },
    ];
    public createAppVehicleOptions = [
        { label: '2W', value: RiderTransportationTypeEnum.Moto },
        { label: '4W', value: RiderTransportationTypeEnum.Car },
    ];
    public createAppRide4WVehicleOptions = [
        { label: 'Sedan', value: RiderVehicleTypeEnum.Sedan },
        { label: 'SUV', value: RiderVehicleTypeEnum.SUV },
    ];

    get canCreateApplication(): boolean {
        return this.appData.hasPermission(
            MenuPermissionConfig.BACK_OFFICE_DRIVERS_REGISTRATION,
            MenuPermissionActionEnum.Create);
    }

    constructor(private messageService: MessageService,
        private riderService: RiderService,
        public configService: ConfigService,
        private signalRService: SignalrService,
        private userService: XpressUserService,
        public appData: AppDataService) {
        this.$onboarding = this.signalRService.OnboardingObservable;
    }

    ngOnInit(): void {
        this.cards = [
            { Header: 'Needs Review', Amount: '', IconPath: '/Content/xpress-app/images/svg/need-review.svg', RegistrationStep: MenuEnum.NeedsReview },
            { Header: 'In Progress', Amount: '', IconPath: '/Content/xpress-app/images/svg/in-progress.svg', RegistrationStep: MenuEnum.InProgress },
            { Header: 'On Hold', Amount: '', IconPath: '/Content/xpress-app/images/svg/on-hold.svg', RegistrationStep: MenuEnum.OnHold },
            { Header: 'Denied', Amount: '', IconPath: '/Content/xpress-app/images/svg/denied.svg', RegistrationStep: MenuEnum.Denied },
            { Header: 'Probation', Amount: '', IconPath: '/Content/xpress-app/images/svg/clock.svg', RegistrationStep: MenuEnum.Probation },
        ];

        this.signalRService.startConnection().then(() => {
            console.log('signalR Service connected');
            this.signalRService.addOnboardingListener();
            this.$onboardingSubject = this.$onboarding.subscribe((data: any) => {
                this.getRegistrationRidersV2();
                console.log('signalR Service: updated riders');
            });
        });

       this.setStepFilter(MenuEnum.NeedsReview);
    }

    ngOnDestroy(): void {
        this.signalRService?.disconnect();
        this.$onboardingSubject?.unsubscribe();
        if (this.searchTimer) {
            clearTimeout(this.searchTimer);
        }
    }

    public handleLazyLoad(event: TableLazyLoadEvent): void {
        if (event.sortField === 'Action') {
            return;
        }

        this.skip = event.first ? event.first : 0;

        if (event.rows) {
            this.rowsPerPage = event.rows;
        }

        if (!event.sortField) {
            this.sortField = 'Id';
            this.sortOrder = -1; // Desc
        }
        else {
            this.sortField = event.sortField;
            this.sortOrder = event.sortOrder ? event.sortOrder : 1;
        }

        this.loadColumnSelectorSettings();
        this.getRegistrationRidersV2();
        if (!this.arrayFilterLastUpdatedBy.length) {
            this.getAdminUsers();
        }
    }

    loadColumnSelectorSettings() {
        if (this.columnSelector) {
            this.columnSelector.loadTableSettings(this.tableName);
        }
    }

    onSelectedColumnsChange(event: any) {
        if (event && event.length > 0) {
            this.cols = event;
        } else {
            this.cols = this.defaultCols;
        }
    }

    public changeTitleName(value: MenuEnum) {
        switch (value) {
            case MenuEnum.NeedsReview:
                this.headerTitleName = 'New Applications';
                this.actionBtnTxt = 'Start Verifying';
                break;
            case MenuEnum.InProgress:
                this.headerTitleName = 'Applications In Progress';
                this.actionBtnTxt = 'Verify';
                break;
            case MenuEnum.OnHold:
                this.headerTitleName = 'Applications On Hold';
                this.actionBtnTxt = 'Verify';
                break;
            case MenuEnum.Denied:
                this.headerTitleName = 'Rejected Applications';
                this.actionBtnTxt = 'Verify';
                break;
            case MenuEnum.Probation:
                this.headerTitleName = 'Applications in Probation';
                this.actionBtnTxt = 'Verify';
                break;
            default:
                this.headerTitleName = 'New Applications';
                this.actionBtnTxt = 'Start Verifying';
        }
    }

    setStepFilter(step: MenuEnum) {
        switch (step) {
            case MenuEnum.NeedsReview:
                this.cols = [
                ...this.commonCols,
                    {
                        field: 'Age', header: 'Age', width: '20%', fieldType: FieldTypeEnum.InputNumber, model: 'age', placeholder: 'Type here',
                        isObject: false, active: false, isLink: false
                    }
                ];
                this.tableName = EditTableConfig.NEEDS_REVIEW;
                break;
            case MenuEnum.InProgress:
                this.cols = [
                    ...this.commonCols,
                    {
                        field: 'UserNameUpdatedBy', header: 'Updated by', width: '20%', disableSort: false, fieldType: FieldTypeEnum.Dropdown,
                        model: 'updatedByUserId', options: this.arrayFilterLastUpdatedBy, placeholder: 'Type here', isObject: false, isLink: false
                    }
                ];
                this.tableName = EditTableConfig.IN_PROGRESS;
                break;
            case  MenuEnum.OnHold:
                this.cols = [...this.commonCols];
                this.tableName = EditTableConfig.ON_HOLD;
                break;
            case MenuEnum.Denied:
                this.cols = [
                    ...this.commonCols,
                    {
                        field: 'RejectedDocuments', header: 'Rejected Documents', width: '20%', fieldType: FieldTypeEnum.Inputs, model: 'rejectedDocuments',
                        placeholder: 'Type here', isObject: false, active: false, isLink: false
                    },
                    {
                        field: 'RejectedReasons', header: 'Rejected Reasons', width: '20%', fieldType: FieldTypeEnum.Inputs, model: 'rejectedReasons',
                        placeholder: 'Type here', isObject: false, active: false, isLink: false
                    },
                    {
                        field: 'UserNameUpdatedBy', header: 'Updated by', width: '20%', disableSort: false, fieldType: FieldTypeEnum.Dropdown,
                        model: 'updatedByUserId', options: this.arrayFilterLastUpdatedBy, placeholder: 'Type here', isObject: false, isLink: false
                    }
                ];
                this.tableName = EditTableConfig.DENIED;
                break;
            case MenuEnum.Probation:
                this.cols = [
                    {
                        field: 'RiderId', header: 'Driver Id', width: '20%', fieldType: FieldTypeEnum.InputNumber, model: 'riderId',
                        placeholder: 'Type here', isObject: false, active: false, isLink: false
                    },
                    {
                        field: 'UserName', header: 'Driver Name', width: '20%', fieldType: FieldTypeEnum.Inputs, model: 'driverName',
                        placeholder: 'Type here', isObject: false, active: false, isLink: true
                    },
                    {
                        field: 'Phone', header: 'Phone No.', width: '20%', fieldType: FieldTypeEnum.Inputs, model: 'phone',
                        placeholder: 'Type here', isObject: false, active: false, isLink: false
                    },
                    {
                        field: 'InspectorUserName', header: 'Verification Name', width: '20%', fieldType: FieldTypeEnum.Inputs, model: 'inspectorName',
                        placeholder: 'Type here', isObject: false, active: false, isLink: false
                    },
                    {
                        field: 'VerificationApplicationDate', header: 'Verification Date', width: '20%', fieldType: FieldTypeEnum.Calendar,
                        model: 'verificationApplicationDate', placeholder: 'Select', isObject: false, isLink: false
                    },
                    {
                        field: 'ProbationDate', header: 'SLA Time', width: '20%', fieldType: FieldTypeEnum.Calendar,
                        model: 'probationDate', placeholder: 'Select', isObject: false, isLink: false
                    }
                ];
                this.tableName = EditTableConfig.PROBATION;
                break;
        }
        this.cols.push(                    {
            field: 'Action', header: 'Action', width: '20%', fieldType: null, model: '', placeholder: '',
            isObject: false, active: false, isLink: false
        });
        this.selectedRegStep = step;
        this.changeTitleName(step);
        this.first = 0;
        this.skip = 0;
        this.onboarding = new OnboardingModel();
        this.onboarding.Items = [];
        this.defaultCols = this.cols.map(x => x);
        this.loadColumnSelectorSettings();
    }

    public getRegistrationRidersV2() {
        const dto = {
            RiderVehicleServiceTypeId: (this.onboardingHeaderSearch.id) ? this.onboardingHeaderSearch.id : null,
            RegistrationStep: this.selectedRegStep,
            SignupDate: (this.onboardingHeaderSearch.signupDate) ? moment(this.onboardingHeaderSearch.signupDate).format('YYYY-MM-DDTHH:mm:ss') : null,
            UserName: (this.onboardingHeaderSearch.driverName) ? this.onboardingHeaderSearch.driverName : null,
            Phone: (this.onboardingHeaderSearch.phone) ? this.onboardingHeaderSearch.phone : null,
            ServiceType: (this.onboardingHeaderSearch.type) ? this.onboardingHeaderSearch.type.serviceType : null,
            VehicleType: (this.onboardingHeaderSearch.type) ? this.onboardingHeaderSearch.type.vehicleType : null,
            Age: (this.onboardingHeaderSearch.age) ? this.onboardingHeaderSearch.age : null,
            RejectedDocuments: (this.onboardingHeaderSearch.rejectedDocuments) ? this.onboardingHeaderSearch.rejectedDocuments : null,
            RejectedReasons: (this.onboardingHeaderSearch.rejectedReasons) ? this.onboardingHeaderSearch.rejectedReasons : null,
            LastUpdate: (this.onboardingHeaderSearch.lastUpdate) ? this.onboardingHeaderSearch.lastUpdate.toString() : '',
            UpdatedByUserId: (this.onboardingHeaderSearch.updatedByUserId) ? this.onboardingHeaderSearch.updatedByUserId : null,
            RiderId: (this.onboardingHeaderSearch.riderId) ? this.onboardingHeaderSearch.riderId : null,
            InspectorUserName: (this.onboardingHeaderSearch.inspectorName) ? this.onboardingHeaderSearch.inspectorName : null,
            VerificationApplicationDate: (this.onboardingHeaderSearch.verificationApplicationDate) ?
                moment(this.onboardingHeaderSearch.verificationApplicationDate).format('YYYY-MM-DDTHH:mm:ss') : null,
            ProbationDate: (this.onboardingHeaderSearch.probationDate) ?
                moment(this.onboardingHeaderSearch.probationDate).format('YYYY-MM-DDTHH:mm:ss') : null,
            TimeZoneOffset: Utils.getTimezoneOffset(),
            Skip: this.skip,
            Take: this.rowsPerPage,
            SortField: this.sortField,
            SortOrder: this.sortOrder
        };

        this.onboarding.Loading = true;
        this.riderService.getRegistrationRidersV2(dto, this.messageService)
            .then(data => {
                this.onboarding.Loading = false;
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.first = dto.Skip;
                this.totalRecords = data.TotalRecords;
                this.onboarding.Items = data.Items;
                this.onboarding.TotalRecords = data.TotalRecords;

                const needReviewCard = this.cards.find((x: TopCardDto) => x.RegistrationStep === MenuEnum.NeedsReview);
                if (needReviewCard) {
                    needReviewCard.Amount = data.Cards.find((x: TopCardDto) => x.Header === 'Needs Review')?.Amount;
                }
                const inProgress = this.cards.find((x: TopCardDto) => x.RegistrationStep === MenuEnum.InProgress);
                if (inProgress) {
                    inProgress.Amount = data.Cards.find((x: TopCardDto) => x.Header === 'In Progress')?.Amount;
                }
                const onHold = this.cards.find((x: TopCardDto) => x.RegistrationStep === MenuEnum.OnHold);
                if (onHold) {
                    onHold.Amount = data.Cards.find((x: TopCardDto) => x.Header === 'On Hold')?.Amount;
                }
                const denied = this.cards.find((x: TopCardDto) => x.RegistrationStep === MenuEnum.Denied);
                if (denied) {
                    denied.Amount = data.Cards.find((x: TopCardDto) => x.Header === 'Denied')?.Amount;
                }
                const probation = this.cards.find((x: TopCardDto) => x.RegistrationStep === MenuEnum.Probation);
                if (probation) {
                    probation.Amount = data.Cards.find((x: TopCardDto) => x.Header === 'Probation')?.Amount;
                }
                if (this.selectedRegStep === MenuEnum.Probation) {
                    this.onboarding.Items.forEach(item => {
                        item.InspectorUserName = item.InspectorUserName || 'New';
                        item.VerificationApplicationDate = item.VerificationApplicationDate
                            ? Utils.utcToFormatedLocalDateStr(item.VerificationApplicationDate)
                            : '';
                        item.ProbationDate = item.ProbationDate
                            ? Utils.utcToFormatedLocalDateStr(item.ProbationDate)
                            : '';
                    });
                }
            })
            .catch(err => {
                this.onboarding.Loading = false;
                throw err;
            });
    }

    getAdminUsers() {
        this.arrayFilterLastUpdatedBy = [ { name: 'All', value: '' } ];

        const dto = {
            Search: '',
            Roles: [XpressUserRoleEnum.Admin]
        };

        this.userService.searchUsersByRole(dto, this.messageService)
            .then(data => {
                if (!data) {
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                data.Items.forEach((item: any) => {
                    this.arrayFilterLastUpdatedBy.push({
                        name: item.UserName,
                        value: item.Id
                    });
                });
            })
            .catch(error => {
                this.onboarding.Loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
                throw error;
            });
    }

    public onChangeHeaderFilter() {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }
        this.searchTimer = window.setTimeout(() => {
            this.getAdminUsers();
            this.getRegistrationRidersV2();
            this.searchTimer = 0;
        }, 1500);
    }

    clearFilters() {
        this.skip = 0;
        this.first = 0;
        this.onboardingHeaderSearch = {
            id: null,
            age: null,
            rejectedDocuments: null,
            rejectedReasons: null,
            signupDate: null,
            type: null,
            driverName: null,
            phone: null,
            status: null,
            lastActiveTypeObj: null,
            updatedByUserId: null,
            riderId: null,
            inspectorName: null,
            verificationApplicationDate: null,
            probationDate: null
        };
        this.getAdminUsers();
        this.getRegistrationRidersV2();
    }

    changedVisibleRegistrationAppProgressEmit(value: any) {
        this.isVisibleRegistrationAppProgressModal = value;
        this.getRegistrationRidersV2();
    }

    public openSideBar(rider: any) {
        if (this.appData.hasPermission(MenuPermissionConfig.BACK_OFFICE_DRIVERS_REGISTRATION, MenuPermissionActionEnum.Create) ||
            this.appData.hasPermission(MenuPermissionConfig.BACK_OFFICE_DRIVERS_REGISTRATION, MenuPermissionActionEnum.Update)) {
            this.selectedRiderId = rider.RiderId;
            this.selectedRiderVehicleId = rider.RiderVehicleId;
            this.selectedXpressUserId = rider.XpressUserId;
            this.riderVehicleServiceTypeId = rider.RiderVehicleServiceTypeId;
            this.getRiderDetailsEditLock();
        }
        else {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Access denied' });
        }
    }

    public setRiderStatus(riderStatus: XpressRiderStatus, riderId: number) {
        this.onboarding.Loading = true;
        const dto = {
            RiderId: riderId,
            RiderStatus: riderStatus
        };
        this.riderService.setRiderStatus(dto, this.messageService)
            .then(data => {
                this.onboarding.Loading = false;

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.getRegistrationRidersV2();
                this.messageService.add({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Successfully updated.'
                });
            })
            .catch(err => {
                this.onboarding.Loading = false;
                throw err;
            });
    }

    startVerify(rider: any) {
        if (this.selectedRegStep === MenuEnum.NeedsReview) {
            this.setRiderStatus(XpressRiderStatus.OnReview, rider.RiderId);
        } else {
            this.openSideBar(rider);
        }
    }

    public openCreateApplicationModal() {
        if (!this.canCreateApplication) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Access denied' });
            return;
        }
        this.createAppForm = this.buildEmptyCreateAppForm();
        this.createAppErrors = {};
        this.showCreateApplicationModal = true;
    }

    public closeCreateApplicationModal() {
        if (this.isCreatingApplication) {
            return;
        }
        this.showCreateApplicationModal = false;
    }

    public isTaxiLikeService(serviceTypeId: ServiceTypeEnum): boolean {
        return serviceTypeId === ServiceTypeEnum.Taxi || serviceTypeId === ServiceTypeEnum.Connex;
    }

    public onCreateAppPathChanged() {
        if (this.isTaxiLikeService(this.createAppForm.serviceTypeId)) {
            this.createAppForm.transportationType = RiderTransportationTypeEnum.Car;
            this.createAppForm.isSalaried = true;
        }
        this.syncCreateAppVehicleTypeId();
    }

    public get showCreateAppRide4WClassification(): boolean {
        return !this.isTaxiLikeService(this.createAppForm.serviceTypeId)
            && this.createAppForm.transportationType === RiderTransportationTypeEnum.Car;
    }

    private syncCreateAppVehicleTypeId(): void {
        if (this.createAppForm.transportationType === RiderTransportationTypeEnum.Moto) {
            this.createAppForm.vehicleTypeId = RiderVehicleTypeEnum.Moto;
            return;
        }

        switch (this.createAppForm.serviceTypeId) {
            case ServiceTypeEnum.Taxi:
                this.createAppForm.vehicleTypeId = RiderVehicleTypeEnum.Taxi;
                break;
            case ServiceTypeEnum.Connex:
                this.createAppForm.vehicleTypeId = RiderVehicleTypeEnum.SUV;
                break;
            default:
                if (this.createAppForm.vehicleTypeId !== RiderVehicleTypeEnum.Sedan
                    && this.createAppForm.vehicleTypeId !== RiderVehicleTypeEnum.SUV) {
                    this.createAppForm.vehicleTypeId = RiderVehicleTypeEnum.Sedan;
                }
                break;
        }
    }

    public submitCreateApplication() {
        if (!this.validateCreateApplicationForm()) {
            return;
        }

        const dto = {
            FullName: this.createAppForm.fullName.trim(),
            Phone: this.toPhilippinesE164(this.createAppForm.phone),
            BirthDate: moment(this.createAppForm.birthDate).format('YYYY-MM-DD'),
            Email: this.createAppForm.email.trim(),
            Address: this.createAppForm.address.trim(),
            EmergencyContactName: this.createAppForm.emergencyContactName.trim(),
            EmergencyContactPhone: this.toPhilippinesE164(this.createAppForm.emergencyContactPhone),
            ServiceTypeId: this.createAppForm.serviceTypeId,
            TransportationType: this.createAppForm.transportationType,
            VehicleTypeId: this.createAppForm.vehicleTypeId,
            IsSalaried: this.createAppForm.isSalaried,
            IsEVDriver: this.createAppForm.isEVDriver
        };

        this.isCreatingApplication = true;
        this.riderService.createDriverApplication(dto, this.messageService)
            .then(data => {
                this.isCreatingApplication = false;
                if (!data?.Success) {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: data?.ErrorMessage || 'Failed to create application'
                    });
                    return;
                }

                this.showCreateApplicationModal = false;
                this.messageService.add({
                    severity: 'success',
                    summary: 'Success',
                    detail: `Application ${data.ApplicationId} created`
                });

                this.selectedRiderId = data.RiderId;
                this.selectedXpressUserId = data.XpressUserId;
                this.selectedRiderVehicleId = data.RiderVehicleId;
                this.riderVehicleServiceTypeId = data.RiderVehicleServiceTypeId;
                // New apps are StatusId=Submitted → Needs Review (not OnReview/In Progress).
                this.setStepFilter(MenuEnum.NeedsReview);
                this.getRegistrationRidersV2();
                this.getRiderDetailsEditLock();
            })
            .catch(err => {
                this.isCreatingApplication = false;
                throw err;
            });
    }

    private buildEmptyCreateAppForm(): CreateApplicationForm {
        return {
            fullName: '',
            phone: '',
            birthDate: null,
            email: '',
            address: '',
            emergencyContactName: '',
            emergencyContactPhone: '',
            serviceTypeId: ServiceTypeEnum.Ride,
            transportationType: RiderTransportationTypeEnum.Car,
            vehicleTypeId: RiderVehicleTypeEnum.Sedan,
            isSalaried: false,
            isEVDriver: false
        };
    }

    public onCreateAppPhoneInput(field: 'phone' | 'emergencyContactPhone') {
        const digitsOnly = (this.createAppForm[field] || '').replace(/\D/g, '').slice(0, 10);
        this.createAppForm[field] = digitsOnly;
    }

    private toPhilippinesE164(localBody: string): string {
        const digits = (localBody || '').replace(/\D/g, '');
        return digits ? `+63${digits}` : '';
    }

    private isPhilippinesMobileBodyValid(localBody: string): boolean {
        // Mobile / driver auth: +63 + 10 digits starting with 9 (e.g. 9123456789).
        return /^9\d{9}$/.test((localBody || '').trim());
    }

    private validateCreateApplicationForm(): boolean {
        const errors: CreateApplicationErrors = {};
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!this.createAppForm.fullName?.trim()) {
            errors.fullName = 'Full name is required.';
        }
        if (!this.isPhilippinesMobileBodyValid(this.createAppForm.phone)) {
            errors.phone = 'Enter a valid PH mobile number (+63 9XXXXXXXXX).';
        }
        if (!this.createAppForm.birthDate) {
            errors.birthDate = 'Date of birth is required.';
        }
        if (!emailRegex.test(this.createAppForm.email?.trim() || '')) {
            errors.email = 'Enter a valid email address.';
        }
        if (!this.createAppForm.address?.trim()) {
            errors.address = 'Full address is required.';
        }
        if (!this.createAppForm.emergencyContactName?.trim()) {
            errors.emergencyContactName = 'Emergency contact name is required.';
        }
        if (!this.isPhilippinesMobileBodyValid(this.createAppForm.emergencyContactPhone)) {
            errors.emergencyContactPhone = 'Enter a valid PH mobile number (+63 9XXXXXXXXX).';
        }

        this.createAppErrors = errors;
        return Object.keys(errors).length === 0;
    }

    getRiderDetailsEditLock() {
        const dto = {
            RiderId: this.selectedRiderId,
            RiderVehicleServiceTypeId: this.riderVehicleServiceTypeId
        };

        this.riderService.getRiderDetailsEditLock(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Could not check editors lock' });
                    return;
                }
                if (data.ErrorCode === ResponceErrorCode.RiderDetailsAreCurrentlyEdited) {
                    this.lockDialogText = data.ErrorMessage;
                    this.showLockDialog = true;
                    return;
                }
                this.isVisibleRegistrationAppProgressModal = true;
            })
            .catch(err => {
                throw err;
            });
    }

    protected readonly RegistrationMenuEnum = RegistrationMenuEnum;
}
